module.exports = __webpack_public_path__ + "static/media/5.ba8b4d14.png";